import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=336899d6&"
import script from "./PanelHeader.vue?vue&type=script&lang=ts&"
export * from "./PanelHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports